import { Box, Heading, SimpleGrid } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { ArrowButton } from '@hover/shared-components';

interface Props {
  backgroundColor: string;
}

const ReadyToStartDesktop: React.FC<Props> = ({ backgroundColor }) => (
  <SimpleGrid
    d={{ base: 'none', desktop: 'grid' }}
    columns={2}
    bg={backgroundColor}
    spacing="auto"
    pl="100px"
    shadow="distance300"
  >
    <Box flexDir="column" alignItems="flex-start" maxW="xl" pt="103px">
      <Heading color="neutral.0" size={700} as="h2">
        Want to learn more?
      </Heading>
      <Heading
        as="p"
        maxW="sm"
        color="neutral.0"
        size={400}
        isDisplay
        marginBottom={800}
      >
        All about how HOVER helps you get the job done.
      </Heading>
      <ArrowButton
        as={GatsbyLink}
        to="/blog/?from=insurance"
        display="block"
        colorScheme="primary"
        variant="inverted"
        type="button"
        w="auto"
      >
        LEARN MORE
      </ArrowButton>
    </Box>
    <Box
      position="relative"
      alignItems="flex-end"
      overflow="hidden"
      justifyContent="flex-end"
    >
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="home"
        src="../../../assets/images/invited_by_contractor_home.png"
      />
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        height={340}
        alt="phone"
        src="../../../assets/images/want_to_learn_more_phone.png"
        style={{ position: 'absolute', bottom: 0, right: '120px' }}
      />
    </Box>
  </SimpleGrid>
);

export default ReadyToStartDesktop;
